import React from "react";
import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Dekontaminace",
    body: "Odstraníme rez, asfalt, letový prach a všechny nečistoty zapuštěné v laku.",
  },
  {
    n: "02",
    title: "Rozleštění laku",
    body: "Profi polishery Flex a Rupes vyrovnají škrábance. Lak získá zpět hloubku barvy.",
  },
  {
    n: "03",
    title: "Sklokeramika Koch",
    body: "Hloubka, mokrý lesk, hydrofobní efekt. Písemná záruka 2 roky na nanesenou vrstvu.",
  },
];

export const Story = () => {
  return (
    <section id="pribeh" data-testid="story-section" className="relative py-20 sm:py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 grid grid-cols-12 gap-y-8 md:gap-10">
        <Reveal className="col-span-12 md:col-span-5 lg:col-span-5">
          <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
            01 — Proměna vašeho auta
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] font-light">
            Z deset let starého auta
            <br />
            <span className="italic text-gold-gradient">uděláme nové.</span>
          </h2>
        </Reveal>

        <Reveal delay={150} className="col-span-12 md:col-span-7 lg:col-span-6 md:col-start-7 space-y-5 md:space-y-6 text-zinc-300 leading-relaxed font-light">
          <p className="text-base sm:text-lg">
            <span className="text-white">Neprodáváme voucher.</span> Prodáváme
            <span className="text-white"> dramatickou proměnu vašeho auta</span> do showroom stavu —
            stejnou péči, jakou připravujeme nová auta pro Škodu, Volvo Průhonice nebo UniCredit Leasing.
          </p>
          <p>
            Pracujeme s prémiovou německou chemií <span className="text-white">Koch Chemie</span>,
            korejským <span className="text-white">Gyeon</span> a švýcarským <span className="text-white">Swiss Wax</span>.
            Detailéři s 10+ lety praxe vrátí vašemu autu hloubku laku, mokrý lesk a 2letou ochranu.
          </p>

          <ol className="grid grid-cols-1 gap-3 sm:gap-4 pt-2">
            {STEPS.map((s) => (
              <li
                key={s.n}
                data-testid={`story-step-${s.n}`}
                className="flex gap-4 border-l border-[#D4AF37]/40 pl-4 sm:pl-5"
              >
                <span className="font-display text-xl sm:text-2xl text-gold-gradient leading-none shrink-0 mt-0.5">
                  {s.n}
                </span>
                <div>
                  <div className="text-white font-medium text-base sm:text-[17px]">{s.title}</div>
                  <div className="text-sm text-zinc-400 mt-1 leading-relaxed">{s.body}</div>
                </div>
              </li>
            ))}
          </ol>

          <div className="pt-2 flex items-center gap-4">
            <span className="w-12 h-px bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-zinc-400">
              Voucher = tato proměna se slevou 33 %
            </span>
          </div>
        </Reveal>
      </div>

      <Reveal delay={250} className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 mt-12 md:mt-20">
        <div className="grid grid-cols-12 gap-3 sm:gap-4 md:gap-6">
          <div className="col-span-12 md:col-span-8 aspect-[16/9] overflow-hidden">
            <img
              src="https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1400&q=80"
              alt="Rozleštění laku luxusního vozu v CarSpa"
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 scale-105 hover:scale-100"
              loading="lazy"
            />
          </div>
          <div className="col-span-12 md:col-span-4 aspect-[16/9] md:aspect-auto overflow-hidden">
            <img
              src="https://images.pexels.com/photos/5233262/pexels-photo-5233262.jpeg?auto=compress&cs=tinysrgb&w=800&q=80"
              alt="Detailer leští lak karoserie rotačním polisherem"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              loading="lazy"
            />
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default Story;
